import React from "react";

import { faExternalLink } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "@material-ui/core";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import { ExternalLink } from "components/Link";

export function externalLinkFormatter(props) {
  const { value, data, isDisabled, disabledTooltip } = props;
  if (!value) {
    return "-";
  }

  if (isDisabled?.(data)) {
    return (
      <Tooltip title={disabledTooltip?.(data) || "Unavailable"}>
        <span>
          <FaIcon icon={faExternalLink} color="gray78" />
        </span>
      </Tooltip>
    );
  }

  return (
    <ExternalLink href={value} target="_blank">
      <FaIcon icon={faExternalLink} />
    </ExternalLink>
  );
}
